const internationalPage = {
  key: 'internationalPage',
  name: 'International Page',

  pageTitle: 'PetSafe® International',
  selectLocationHeader: 'Choose Your Country',
};

exports.internationalPage = internationalPage;
